import { pickGmwLibraryFields } from "../../../schema/gmw-schema-library";

import type { SourcedocumentDataSchemaFor } from "./_gmw-event-schema-collection";

export const gmwGroundLevelMeasuringSchema: SourcedocumentDataSchemaFor<"GMW_GroundLevelMeasuring"> =
  {
    type: "object",
    title: "Gebeurtenis gegevens",
    required: ["eventDate", "groundLevelPosition", "groundLevelPositioningMethod"],
    properties: pickGmwLibraryFields([
      "eventDate",
      "groundLevelPosition",
      "groundLevelPositioningMethod",
    ]),
  };
